import { render, staticRenderFns } from "./callsidebar.vue?vue&type=template&id=4a98275a"
import script from "./callsidebar.vue?vue&type=script&lang=js"
export * from "./callsidebar.vue?vue&type=script&lang=js"
import style0 from "./callsidebar.vue?vue&type=style&index=0&id=4a98275a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports